import './DotLoader.css';

const DotLoader = () => {
    return (
        <div className="dots-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};
export default DotLoader;